import { render, staticRenderFns } from "./projects-edit.vue?vue&type=template&id=7df35ecc&scoped=true&"
import script from "./projects-edit.vue?vue&type=script&lang=js&"
export * from "./projects-edit.vue?vue&type=script&lang=js&"
import style0 from "./projects-edit.vue?vue&type=style&index=0&id=7df35ecc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df35ecc",
  null
  
)

export default component.exports